import { Course } from '../types/course'
// @cspell: disable
export const courses: Record<string, Course> = {
  watercolours: {
    id: 'watercolours',
    namespace: 'watercolours',
    storagePrefix: 'watercolours',
    videoBasePath: 'online_courses/watercolour',
    routePath: 'watercolours-course',
    chapters: [
      {
        code: '00_unboxing_watercolours',
        duration: '3:17',
        titleKey: 'chapters.unboxing'
      },
      {
        code: '01_introduction',
        duration: '1:44',
        titleKey: 'chapters.introduction'
      },
      {
        code: '02_techniques',
        duration: '29:29',
        titleKey: 'chapters.techniques'
      },
      {
        code: '03_colour_mixing_workshop',
        duration: '40:26',
        titleKey: 'chapters.colourMixingWorkshop'
      },
      {
        code: '04_mini_paintings-intro',
        duration: '1:46',
        titleKey: 'chapters.miniPaintingsIntro'
      },
      {
        code: '05_seascape',
        duration: '13:46',
        titleKey: 'chapters.seascape'
      },
      {
        code: '06_floral_workshop',
        duration: '14:41',
        titleKey: 'chapters.floralWorkshop'
      },
      {
        code: '07_throughthetrees',
        duration: '17:32',
        titleKey: 'chapters.throughTheTrees'
      },
      {
        code: '08_still_life-apple',
        duration: '16:55',
        titleKey: 'chapters.stillLifeApple'
      },
      {
        code: '09_mini_painting-wrap_up',
        duration: '1:32',
        titleKey: 'chapters.miniPaintingWrapUp'
      },
      {
        code: '10_watercolour-final_wrap_up',
        duration: '1:35',
        titleKey: 'chapters.finalWrapUp'
      },
      {
        code: '11_bonus_landscape',
        duration: '16:11',
        titleKey: 'chapters.bonusLandscape'
      }
    ],
    metaTitleKey: 'meta.title',
    courseTitleKey: 'title',
    titleTranslations: {
      'en-GB': 'Watercolours Course',
      'en-US': 'Watercolours Course',
      de: 'Aquarellkurs',
      fr: 'Cours d\'Aquarelle',
      it: 'Corso di Acquerelli',
      es: 'Curso de Acuarelas'
    },
    chaptersTranslations: {
      'en-GB': {
        unboxing: 'Unboxing',
        introduction: 'Introduction',
        techniques: 'Techniques',
        colourMixingWorkshop: 'Colour Mixing Workshop',
        miniPaintingsIntro: 'Mini Paintings - Intro',
        seascape: 'Seascape',
        floralWorkshop: 'Floral Workshop',
        throughTheTrees: 'Through the Trees',
        stillLifeApple: 'Still Life - Apple',
        miniPaintingWrapUp: 'Mini Painting - Wrap Up',
        finalWrapUp: 'Final Wrap Up',
        bonusLandscape: 'Bonus - Landscape'
      },
      'en-US': {
        unboxing: 'Unboxing',
        introduction: 'Introduction',
        techniques: 'Techniques',
        colourMixingWorkshop: 'Colour Mixing Workshop',
        miniPaintingsIntro: 'Mini Paintings - Intro',
        seascape: 'Seascape',
        floralWorkshop: 'Floral Workshop',
        throughTheTrees: 'Through the Trees',
        stillLifeApple: 'Still Life - Apple',
        miniPaintingWrapUp: 'Mini Painting - Wrap Up',
        finalWrapUp: 'Final Wrap Up',
        bonusLandscape: 'Bonus - Landscape'
      },
      de: {
        unboxing: 'Auspacken',
        introduction: 'Einführung',
        techniques: 'Techniken',
        colourMixingWorkshop: 'Farbmisch-Workshop',
        miniPaintingsIntro: 'Miniatur-Gemälde - Einführung',
        seascape: 'Seelandschaft',
        floralWorkshop: 'Blumen-Workshop',
        throughTheTrees: 'Durch die Bäume',
        stillLifeApple: 'Stillleben - Apfel',
        miniPaintingWrapUp: 'Miniatur-Gemälde - Zusammenfassung',
        finalWrapUp: 'Abschließende Zusammenfassung',
        bonusLandscape: 'Bonus - Landschaft'
      },
      fr: {
        unboxing: 'Déballage',
        introduction: 'Introduction',
        techniques: 'Techniques',
        colourMixingWorkshop: 'Atelier de Mélange des Couleurs',
        miniPaintingsIntro: 'Mini Peintures - Introduction',
        seascape: 'Paysage Marin',
        floralWorkshop: 'Atelier Floral',
        throughTheTrees: 'À travers les Arbres',
        stillLifeApple: 'Nature Morte - Pomme',
        miniPaintingWrapUp: 'Mini Peinture - Résumé',
        finalWrapUp: 'Résumé Final',
        bonusLandscape: 'Bonus - Paysage'
      },
      it: {
        unboxing: 'Unboxing',
        introduction: 'Introduzione',
        techniques: 'Tecniche',
        colourMixingWorkshop: 'Laboratorio di Miscelazione dei Colori',
        miniPaintingsIntro: 'Mini Dipinti - Introduzione',
        seascape: 'Paesaggio Marino',
        floralWorkshop: 'Laboratorio Floreale',
        throughTheTrees: 'Attraverso gli Alberi',
        stillLifeApple: 'Natura Morta - Mela',
        miniPaintingWrapUp: 'Mini Dipinto - Conclusione',
        finalWrapUp: 'Conclusione Finale',
        bonusLandscape: 'Bonus - Paesaggio'
      },
      es: {
        unboxing: 'Desempaquetado',
        introduction: 'Introducción',
        techniques: 'Técnicas',
        colourMixingWorkshop: 'Taller de Mezcla de Colores',
        miniPaintingsIntro: 'Mini Cuadros - Introducción',
        seascape: 'Paisaje Marino',
        floralWorkshop: 'Taller Floral',
        throughTheTrees: 'A Través de los Árboles',
        stillLifeApple: 'Naturaleza Muerta - Manzana',
        miniPaintingWrapUp: 'Mini Cuadro - Conclusión',
        finalWrapUp: 'Conclusión Final',
        bonusLandscape: 'Bonus - Paisaje'
      }
    },
    reviewUrls: {
      'en-GB': 'https://www.amazon.co.uk/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F7JXWJBC',
      'en-US': 'https://www.amazon.com/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F7JXWJBC',
      de: 'https://www.amazon.de/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F7JXWJBC',
      fr: 'https://www.amazon.fr/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F7JXWJBC',
      it: 'https://www.amazon.it/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F7JXWJBC',
      es: 'https://www.amazon.es/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F7JXWJBC'
    }
  },
  acrylicInk: {
    id: 'acrylicInk',
    namespace: 'acrylicInk',
    storagePrefix: 'acrylic_ink',
    videoBasePath: 'online_courses/acrylic_ink',
    routePath: 'acrylic-ink-course',
    chapters: [
      {
        code: '00_unboxing',
        duration: '4:01',
        titleKey: 'chapters.unboxing'
      },
      {
        code: '01_introduction',
        duration: '2:24',
        titleKey: 'chapters.introduction'
      },
      {
        code: '02_techniques_workshop',
        duration: '16:56',
        titleKey: 'chapters.techniquesWorkshop'
      },
      {
        code: '03_demo_introduction',
        duration: '1:29',
        titleKey: 'chapters.demoIntroduction'
      },
      {
        code: '04_neon_landscape',
        duration: '7:01',
        titleKey: 'chapters.neonLandscape'
      },
      {
        code: '05_pepper',
        duration: '8:01',
        titleKey: 'chapters.pepper'
      },
      {
        code: '06_abstract',
        duration: '19:41',
        titleKey: 'chapters.abstract'
      },
      {
        code: '07_tree_landscape',
        duration: '22:12',
        titleKey: 'chapters.treeLandscape'
      },
      {
        code: '08_final_wrap_up',
        duration: '1:28',
        titleKey: 'chapters.finalWrapUp'
      },
      {
        code: '09_alternative_tools',
        duration: '25:23',
        titleKey: 'chapters.alternativeTools'
      }
    ],
    metaTitleKey: 'meta.title',
    courseTitleKey: 'title',
    titleTranslations: {
      'en-GB': 'Acrylic Ink Course',
      'en-US': 'Acrylic Ink Course',
      de: 'Acryltusche-Kurs',
      fr: 'Cours d\'Encre Acrylique',
      it: 'Corso di Inchiostro Acrilico',
      es: 'Curso de Tinta Acrílica'
    },
    chaptersTranslations: {
      'en-GB': {
        unboxing: 'Unboxing',
        introduction: 'Introduction',
        techniquesWorkshop: 'Techniques Workshop',
        demoIntroduction: 'Demo Introduction',
        neonLandscape: 'Neon Landscape',
        pepper: 'Pepper',
        abstract: 'Abstract',
        treeLandscape: 'Tree Landscape',
        finalWrapUp: 'Final Wrap Up',
        alternativeTools: 'Alternative Tools'
      },
      'en-US': {
        unboxing: 'Unboxing',
        introduction: 'Introduction',
        techniquesWorkshop: 'Techniques Workshop',
        demoIntroduction: 'Demo Introduction',
        neonLandscape: 'Neon Landscape',
        pepper: 'Pepper',
        abstract: 'Abstract',
        treeLandscape: 'Tree Landscape',
        finalWrapUp: 'Final Wrap Up',
        alternativeTools: 'Alternative Tools'
      },
      de: {
        unboxing: 'Auspacken',
        introduction: 'Einführung',
        techniquesWorkshop: 'Techniken-Workshop',
        demoIntroduction: 'Demo-Einführung',
        neonLandscape: 'Neon-Landschaft',
        pepper: 'Paprika',
        abstract: 'Abstrakt',
        treeLandscape: 'Baum-Landschaft',
        finalWrapUp: 'Abschließende Zusammenfassung',
        alternativeTools: 'Alternative Werkzeuge'
      },
      fr: {
        unboxing: 'Déballage',
        introduction: 'Introduction',
        techniquesWorkshop: 'Atelier de Techniques',
        demoIntroduction: 'Introduction à la Démo',
        neonLandscape: 'Paysage Néon',
        pepper: 'Poivre',
        abstract: 'Abstrait',
        treeLandscape: 'Paysage Arboré',
        finalWrapUp: 'Résumé Final',
        alternativeTools: 'Outils Alternatifs'
      },
      it: {
        unboxing: 'Unboxing',
        introduction: 'Introduzione',
        techniquesWorkshop: 'Laboratorio di Tecniche',
        demoIntroduction: 'Introduzione alla Demo',
        neonLandscape: 'Paesaggio Neon',
        pepper: 'Pepe',
        abstract: 'Astratto',
        treeLandscape: 'Paesaggio con Alberi',
        finalWrapUp: 'Conclusione Finale',
        alternativeTools: 'Strumenti Alternativi'
      },
      es: {
        unboxing: 'Desempaquetado',
        introduction: 'Introducción',
        techniquesWorkshop: 'Taller de Técnicas',
        demoIntroduction: 'Introducción a la Demo',
        neonLandscape: 'Paisaje Neón',
        pepper: 'Pimiento',
        abstract: 'Abstracto',
        treeLandscape: 'Paisaje Arbolado',
        finalWrapUp: 'Conclusión Final',
        alternativeTools: 'Herramientas Alternativas'
      }
    },
    reviewUrls: {
      'en-GB': 'https://www.amazon.co.uk/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F9586H16',
      'en-US': 'https://www.amazon.com/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F9586H16',
      de: 'https://www.amazon.de/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F9586H16',
      fr: 'https://www.amazon.fr/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F9586H16',
      it: 'https://www.amazon.it/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F9586H16',
      es: 'https://www.amazon.es/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0F9586H16'
    }
  },
  facePaintCrayons: {
    id: 'facePaintCrayons',
    namespace: 'facePaintCrayons',
    storagePrefix: 'face_paint_crayons',
    videoBasePath: 'online_courses/face_paint_crayons',
    routePath: 'face-paint-crayons-course',
    chapters: [
      {
        code: '01_Dino',
        duration: '1:59',
        titleKey: 'chapters.dino'
      },
      {
        code: '02_Fox',
        duration: '2:58',
        titleKey: 'chapters.fox'
      },
      {
        code: '03_Spiderman',
        duration: '3:48',
        titleKey: 'chapters.spiderman'
      },
      {
        code: '04_Tiger',
        duration: '4:24',
        titleKey: 'chapters.tiger'
      },
      {
        code: '05_Butterfly',
        duration: '5:19',
        titleKey: 'chapters.butterfly'
      },
      {
        code: '06_Lion',
        duration: '3:08',
        titleKey: 'chapters.lion'
      }
    ],
    metaTitleKey: 'meta.title',
    courseTitleKey: 'title',
    titleTranslations: {
      'en-GB': 'Face Paint Crayons Course',
      'en-US': 'Face Paint Crayons Course',
      de: 'Gesichtsbemalung Stift Kurs',
      fr: 'Cours de Crayons de Maquillage Visage',
      it: 'Corso di Matite per Trucco Viso',
      es: 'Curso de Lápices de Pintura Facial'
    },
    chaptersTranslations: {
      'en-GB': {
        dino: 'Dino',
        fox: 'Fox',
        spiderman: 'Spiderman',
        tiger: 'Tiger',
        butterfly: 'Butterfly',
        lion: 'Lion'
      },
      'en-US': {
        dino: 'Dino',
        fox: 'Fox',
        spiderman: 'Spiderman',
        tiger: 'Tiger',
        butterfly: 'Butterfly',
        lion: 'Lion'
      },
      de: {
        dino: 'Dino',
        fox: 'Fuchs',
        spiderman: 'Spiderman',
        tiger: 'Tiger',
        butterfly: 'Schmetterling',
        lion: 'Löwe'
      },
      fr: {
        dino: 'Dino',
        fox: 'Renard',
        spiderman: 'Spiderman',
        tiger: 'Tigre',
        butterfly: 'Papillon',
        lion: 'Lion'
      },
      it: {
        dino: 'Dino',
        fox: 'Volpe',
        spiderman: 'Spiderman',
        tiger: 'Tigre',
        butterfly: 'Farfalla',
        lion: 'Leone'
      },
      es: {
        dino: 'Dino',
        fox: 'Zorro',
        spiderman: 'Spiderman',
        tiger: 'Tigre',
        butterfly: 'Mariposa',
        lion: 'León'
      }
    },
    reviewUrls: {
      'en-GB': 'https://www.amazon.co.uk/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0DXSTRGRZ',
      'en-US': 'https://www.amazon.com/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0DXSTRGRZ',
      de: 'https://www.amazon.de/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0DXSTRGRZ',
      fr: 'https://www.amazon.fr/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0DXSTRGRZ',
      it: 'https://www.amazon.it/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0DXSTRGRZ',
      es: 'https://www.amazon.es/review/create-review/?ie=UTF8&channel=glance-detail&asin=B0DXSTRGRZ'
    }
  }
}